// extracted by mini-css-extract-plugin
export default {"container":"Notification_container__IB9Uk","message":"Notification_message__1F9mV"};